<ng-template #priceListPreview let-modal>
  <div class="modal-header" style="padding: 10px;">
    <h6 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">Price List Details</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="font-size: 12px;">
    <div class="row">
      <div class="col-12">
        <section class="price-list-container">
          <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
            [filtersComponent]="dataFilters" [pageSize]="15" (onTableRowClick)="onProductTableRowClick($event)">
            <app-data-filters #dataFilters>
              <app-data-filter-group>
                <app-data-filter-input label="Id" [(model)]="filters.productId" placeholder="Id">
                </app-data-filter-input>
                <app-data-filter-select label="Category" [(model)]="filters.categoryId" [options]="categoryOptions">
                </app-data-filter-select>
                <app-data-filter-input label="Product Name" [(model)]="filters.productName" placeholder="Product Name">
                </app-data-filter-input>
              </app-data-filter-group>
            </app-data-filters>
          </app-data-table>
        </section>
      </div>
    </div>
    <div class="row" [hidden]="hideOptionsTable">
      <div class="col-12">
        <hr />
        <table class="table table-hover table-bordered table-sm">
          <thead class="thead-dark">
            <th>Id</th>
            <th>Product Name</th>
            <th>Option Name</th>
            <th>Extra Info</th>
            <th>Price</th>
            <th>Status</th>
          </thead>
          <tbody>
            <tr *ngFor="let options of selectedProduct.productOptions">
              <td>{{options.id}}</td>
              <td>{{selectedProduct.name}}</td>
              <td>{{options.name}}</td>
              <td>{{options.extraInfo}}</td>
              <td>{{options.price}}</td>
              <td>{{options.status}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <a href="/price-lists/edit/{{priceListId}}" class="btn btn-sm btn-default">Modify</a>
    <button type="button" class="btn btn-sm btn-primary" (click)="modal.dismiss('close')">Close</button>
  </div>
</ng-template>

<button type="button" class="btn btn-sm btn-primary" (click)="open(priceListPreview)"
  [disabled]="disabled">Details</button>

<ng-template #productId let-productId="productId">
  {{productId}}
</ng-template>

<ng-template #productCategoryColumn let-categoryName="categoryName">
  {{categoryName}}
</ng-template>

<ng-template #productNameColumn let-productName="productName">
  {{productName}}
</ng-template>

<ng-template #extraInfoColumn let-productExtraInfo="productExtraInfo">
  {{productExtraInfo}}
</ng-template>

<ng-template #priceColumn let-productPrice="productPrice">
  {{productPrice}}
</ng-template>

<ng-template #statusColumn let-productStatus="productStatus">
  {{productStatus}}
</ng-template>

<ng-template #optionsColumn let-optionsCount="optionsCount">
  {{ (optionsCount === 0 ? 'No Options' : optionsCount + ' Options present') }}
</ng-template>